import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Lecture } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Delete Course lecture content
 * @param course_id
 * @param version
 * @param sectionId
 * @param lectureId
 * @param contentId
 */
const deleteCourseLectureContent = (
  course_id: string,
  version: number,
  sectionId: string,
  lectureId: string,
  contentId: string
): Promise<Lecture> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures/' +
      lectureId +
      '/contents/' +
      contentId
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.delete(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default deleteCourseLectureContent
